module.exports = __webpack_public_path__ + "static/media/aakash.1eb2abdd.png";